export const SOCIAL_WALLET_TYPE = 'social-wallet';
export const providerGeneralMetadata = {
    name: 'Easy Connect',
    icon: 'https://app.rango.exchange/imgs/wallets/social-wallet.svg',
    extensions: {
        homepage: 'https://www.privy.io/',
    },
};
